import { render, staticRenderFns } from "./SwitchWindow.vue?vue&type=template&id=7a889e2c"
import script from "./SwitchWindow.vue?vue&type=script&lang=js"
export * from "./SwitchWindow.vue?vue&type=script&lang=js"
import style0 from "./SwitchWindow.vue?vue&type=style&index=0&id=7a889e2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports